import React, { useContext, useState } from 'react';
import ChildHeader from '../../ChildHeader';
import { Box, Heading, Image, Img, Text, useMediaQuery, VStack } from '@chakra-ui/react';
import ListaMedicos from './ListaMedicos';
import SearchContext from '../../SearchContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import Contact from '../../../../../images/ClinicoIcon.svg';
import NoUserHeader from 'components/AreaLivre/NoUserHeader';
import TelemedDeslogado from '../../../../../images/Deslogado/telemedDeslogado.svg';

import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import BottomNavBar from 'components/BottomNavBar';
function Medicos({ ...rest }) {
  const { user, setPage, setUser } = useContext(AccountContext);
  const [loading, setLoading] = useState(true);
  const state = useLocation();
  const { typeList } = state.state;

  const { especialidade, pacienteEscolhido, nascimento, idClientClinica, segunda_consulta, sexo } = state?.state;
  const navigate = useNavigate();
  setPage(typeList === 'Outros' ? 'Profissionais de Saúde' : typeList === 'Medicos' ? 'Médicos' : typeList);
  const [telefonePequeno] = useMediaQuery('(max-height: 592px)');
  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  return (
    <>
      <VStack
        align="center"
        justify={{
          base: 'center',
          md: 'space-around',
          xl: 'space-between',
        }}
        direction={{ base: 'column-reverse' }}
        wrap="no-wrap"
        minH={telefonePequeno ? "105vh" : '100vh'}
        spacing={0}
        background={usuarioAssinante ? '#5AB2AE' : '#5AB2AE'}
        color="#585858"
        mb={telefonePequeno ? '1em' : ''}
      >
        <Image
          top={telefonePequeno ? 'calc(env(safe-area-inset-top, 0px) + 0.5em)' : 'calc(env(safe-area-inset-top, 0px) + 1em)'}
          left="1.3em"
          zIndex="9999"
          position="absolute"
          boxSize={{ base: '32px', sm: '40px' }}
          src={BackButton}
          onClick={() => navigate(-1)}
        />
        <Box
          mt="1"
          id=""
          as="card"
          minHeight={telefonePequeno ? '85vh' : "75vh"}
          borderRadius="18px"
          fontSize="xs"
          size="10"
          backgroundColor="white"
          textAlign="center"
          maxW={telefonePequeno ? "90vw" : '80vw'}
          mb={telefonePequeno ? '2em' : ''}
        >
          <Img ml="40%" mt={telefonePequeno ? '2%' : "15%"} src={usuarioAssinante ? Contact : TelemedDeslogado}  w="15%" />
          <Heading m="2%" size="xs">
            Profissionais de Saúde
          </Heading>
          <Heading m="2%" size="xs">
            com agenda disponivel
          </Heading>
          <Text fontSize="14px" mt="1em" color="#585858">
            Selecione um profissional
          </Text>

          <SearchContext>
            <VStack
              align="start"
              mt="5%"
              w="100%"
              direction={{ base: 'column-reverse' }}
              wrap="no-wrap"
              minH="10vh"
              maxH={telefonePequeno ? "55vh" : '50vh'}
              overflowX="scroll"
              px={4}
              {...rest}
              typeList={typeList}
              sexo={sexo}
            >
              <ListaMedicos isLoading={(value) => setLoading(value)} typeList={typeList} especialidade={especialidade} especialidade_id={especialidade} paciente={pacienteEscolhido} nascimento={nascimento} idClientClinica={idClientClinica} segunda_consulta={segunda_consulta} sexo={sexo}/>
            </VStack>
          </SearchContext>
        </Box>
      </VStack>
      <BottomNavBar />
    </>
  );
}

export default Medicos;
